export const customerReducer = (state, action) => {
    switch (action.type) {
        case 'SET_LOADING':
            return { ...state, loading: action.payload };
        case 'SET_CUSTOMERS':
            return { ...state, customers: action.payload, loading: false };
        case 'SET_UPLOAD_PROGRESS':
            return { ...state, uploadProgress: action.payload };
        case 'SET_WORKER_STATUS':
            return { ...state, workerStatus: action.payload };
        case 'SET_ERROR':
            return { ...state, error: action.payload, loading: false };
        case 'SET_STOCK_PREDICTIONS':
            return { ...state, stockPredictions: action.payload };
        case 'SET_COMPLAINT_ANALYTICS':
            return { ...state, complaintAnalytics: action.payload };
        default:
            return state;
    }
};

export const initialState = {
    customers: [],
    loading: false,
    error: null,
    uploadProgress: 0,
    workerStatus: 'idle', // idle, parsing, aggregating, uploading, complete
    stockPredictions: [],
    complaintAnalytics: []
};
